// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Counterparty } from './counterparty';
import { Employee } from './employee';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class SuperFund extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  superfundId!: number;
  accountName?: string;
  accountNo?: string;
  bsb?: string;
  counterpartyId?: number;
  createdBy!: string;
  createdDate!: Date;
  description!: string;
  esa?: string;
  flags?: number;
  locationId!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  usi?: string;
  counterparty!: Counterparty;
  employees!: Employee[];
}

